var map = {
	"./1_referral.png": 55616,
	"./2_referral-banner-mobile.png": 43088,
	"./2_referral-banner.jpg": 61220,
	"./affiliate.png": 1362,
	"./announcement.png": 79302,
	"./app-store.png": 68813,
	"./approved.png": 49773,
	"./attention.png": 3283,
	"./blue-user.png": 86181,
	"./change-email.png": 45078,
	"./cloud.png": 62903,
	"./curved-arrow-right.png": 80287,
	"./edit.png": 49450,
	"./enter-code-disable.svg": 86905,
	"./enter-code.svg": 10731,
	"./gradient-2fa.png": 10614,
	"./gradient-ch_lang.png": 95089,
	"./gradient-cloud.png": 76738,
	"./gradient-communication.png": 79002,
	"./gradient-download.png": 16546,
	"./gradient-email.png": 42946,
	"./gradient-en_lang.png": 84345,
	"./gradient-global.png": 76828,
	"./gradient-language.png": 53935,
	"./gradient-malaysia.png": 43042,
	"./gradient-news.png": 35436,
	"./gradient-passkey.png": 59588,
	"./gradient-password.png": 68352,
	"./gradient-pending.png": 96122,
	"./gradient-phone.png": 58212,
	"./gradient-platform.png": 27198,
	"./gradient-reward.png": 5662,
	"./gradient-security.png": 3333,
	"./gradient-setting.png": 19067,
	"./gradient-share.png": 33326,
	"./gradient-support24.png": 36969,
	"./gradient-user.png": 9939,
	"./gradient-user2.png": 69352,
	"./gradient-verify.png": 30071,
	"./gray-reward.png": 10176,
	"./grey-invitees.png": 63258,
	"./identification-approved.png": 56038,
	"./identification-pending.png": 96841,
	"./identification-rejected.png": 83338,
	"./language.svg": 81368,
	"./no-notification.png": 11559,
	"./noti-delete.png": 88652,
	"./noti-delete.svg": 35224,
	"./noti-indivi-delete.svg": 22629,
	"./noti-read.png": 74472,
	"./noti-read.svg": 92457,
	"./passkeys.png": 6024,
	"./pending.png": 28749,
	"./platform_success.png": 91266,
	"./play-store.png": 75302,
	"./referral-rewards.png": 89495,
	"./rejected.png": 22282,
	"./reward.png": 61462,
	"./share-disable.svg": 49386,
	"./share.svg": 35777,
	"./singleRef_icon.png": 55744,
	"./support24.svg": 39805,
	"./warning.svg": 48183
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96385;